export default "__VITE_ASSET__BJhwl4dm__"